
import Navbar from './header';
import HeroSlider from './components/HeroSlider';
import Footer from './footer';
import DoctorList from './components/doctorList';
import PremiumAuthSection from './components/PremiumAuthSection';

import { useContext, useEffect, useState } from 'react';
import { AuthContext } from './util/api';

export default function Home() {

  const { token  } = useContext(AuthContext);
  const [isLoggedIn, setIsLoggedIn] = useState(false);


  useEffect(() => {
    if (token !=  null ) {

       setIsLoggedIn(true);
    }
  }, [token]);

  return (
    <>

      <Navbar  showlogo={false} />


      <HeroSlider />

      <div class="line-vr-section"></div>

      <div>
      <PremiumAuthSection isLoggedIn={isLoggedIn} />
    </div>

     <div class="line-vr-section"></div>

      <DoctorList />

      <div class="line-vr-section"></div>



      <Footer />

    </>
  );
}
